import React, { Component } from 'react';
import MenuButton from '../Components/MenuButton.js';
import styled from 'styled-components';
import BurgerMenu from "./BurgerMenu";

const MenuAlignRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;
  
  @media (max-width: 799px) {
    display: none;
  } 
`;

const GiftButton = styled(MenuButton)`
  @media (max-width: 799px) {
    display: none !important;
  } 
`;

class PageMenu extends Component {
  render() {
    return (
      <div className="pagemenu">
        <MenuAlignRight>
          <MenuButton to={'/about'}>About</MenuButton>
          <MenuButton to={'/faq'}>FAQ</MenuButton>
          <MenuButton href={'https://medium.com/@biterica'} target="_blank">Learn</MenuButton>
          <GiftButton primary="true" to={'/recipient'}>Send Coins</GiftButton>
        </MenuAlignRight>
        <BurgerMenu>
          <MenuButton to={'/about'}>About</MenuButton>
          <MenuButton to={'/faq'}>FAQ</MenuButton>
          <MenuButton href={'https://medium.com/@biterica'} target="_blank">Learn</MenuButton>
          <MenuButton to={'/recipient'}>Send Coins</MenuButton>
        </BurgerMenu>
      </div>
    );
  }
}

export default PageMenu;



// WEBPACK FOOTER //
// ./src/Containers/PageMenu.js